export default "__VITE_ASSET__CiDtL0fz__"